import { clsx } from 'clsx';
import Box from '../Box/Box.js';
import classes from './Label.module.css.js';
import React from 'react';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const Label = /*#__PURE__*/React.forwardRef(function Label({
  as,
  size = 'small',
  variant = 'default',
  className,
  ...rest
}, ref) {
  const Component = as || 'span';
  if (rest.sx) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      as: Component,
      className: clsx(className, classes.Label),
      "data-size": size,
      "data-variant": variant,
      ref: ref
    }, rest));
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: clsx(className, classes.Label),
    "data-size": size,
    "data-variant": variant
  }, rest));
});

export { Label as default };
